import { render, staticRenderFns } from "./MemberView.vue?vue&type=template&id=45d1d7ad&"
import script from "./MemberView.vue?vue&type=script&lang=js&"
export * from "./MemberView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports